import {Component, Input} from "@angular/core";
import {TranslatableComponent} from "../../../core/models/TranslatableComponent";
import {TranslateService, TranslatePipe} from "@ngx-translate/core";
import {MatTooltip} from "@angular/material/tooltip";
import {NgClass} from "@angular/common";

@Component({
	selector: "app-traffic-light-mec-mep",
	templateUrl: "./traffic-light-mec-mep.component.html",
	styleUrls: ["./traffic-light-mec-mep.component.scss"],
	imports: [MatTooltip, NgClass, TranslatePipe],
})
export class TrafficLightMecMepComponent extends TranslatableComponent {
	@Input()
	selectedFamilyGroup: string;

	@Input()
	workload: number;

	readonly MB_GREEN_THRESHOLD = 80;
	readonly MB_YELLOW_THRESHOLD = 72;
	readonly B_GREEN_THRESHOLD = 92;
	readonly B_YELLOW_THRESHOLD = 83;

	constructor(private translateService: TranslateService) {
		super(translateService, "HomeScreenComponent");
	}

	private getRoundedWorkload(): number {
		return Math.round(this.workload * 10) / 10;
	}

	isGreen(): boolean {
		const roundedWorkload = this.getRoundedWorkload();
		return this.selectedFamilyGroup === "M_B"
			? roundedWorkload >= this.MB_GREEN_THRESHOLD
			: roundedWorkload >= this.B_GREEN_THRESHOLD;
	}

	isYellow(): boolean {
		const roundedWorkload = this.getRoundedWorkload();
		return this.selectedFamilyGroup === "M_B"
			? roundedWorkload >= this.MB_YELLOW_THRESHOLD && roundedWorkload < this.MB_GREEN_THRESHOLD
			: roundedWorkload >= this.B_YELLOW_THRESHOLD && roundedWorkload < this.B_GREEN_THRESHOLD;
	}

	isRed(): boolean {
		const roundedWorkload = this.getRoundedWorkload();
		return (
			roundedWorkload > 0 &&
			(this.selectedFamilyGroup === "M_B"
				? roundedWorkload < this.MB_YELLOW_THRESHOLD
				: roundedWorkload < this.B_YELLOW_THRESHOLD)
		);
	}
}
